import { Injectable, SecurityContext } from '@angular/core';
import { SafeValue, ɵDomSanitizerImpl } from '@angular/platform-browser';

const RUSSIAN_LETTERS_SANITAIZED_REGEX = ((): RegExp => {
  const letters = 'АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюяёЁ';
  const codes = [...Array(letters.length).keys()].map((index) => String(letters.charCodeAt(index))).join('|');

  return new RegExp(`(&#(${codes});)`, 'g');
})();

@Injectable()
export class CustomDomSanitaizer extends ɵDomSanitizerImpl {
  sanitize(ctx: SecurityContext, value: SafeValue | string | null): string | null {
    let sanitizedValue = super.sanitize(ctx, value);
    if (ctx === SecurityContext.HTML && sanitizedValue) {
      sanitizedValue = sanitizedValue.replace(RUSSIAN_LETTERS_SANITAIZED_REGEX, (match: string) =>
        String.fromCharCode(Number(match.substring(2, match.length - 1))),
      );
    }

    return sanitizedValue;
  }
}
